import type { IFolderNode } from 'src/app/documents/folderNode';

/** @registry Depth-first search for a folder id in a nested folder list, returning the ancestor chain from the top-level folder down to the match (empty when the id is not in the tree). */
export const findFolderPath = <T extends IFolderNode & { children?: T[] }>(
  folders: T[],
  id: string,
): T[] => {
  for (const folder of folders) {
    if (folder.id === id) return [folder];

    const nested = findFolderPath(folder.children ?? [], id);
    if (nested.length > 0) return [folder, ...nested];
  }

  return [];
};
